import { Box, Chip, Tooltip } from "@mui/material"
import { KeyboardArrowRightOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { formatTruncatedFileName, handleFileAction } from "../../utils"

import type { SignedUrl } from "@/graphql/codegen/graphql"

interface FileChipProps {
  file: SignedUrl
  showExtension?: boolean
  showFileName?: boolean
}

const FileChip: FC<FileChipProps> = ({ file, showExtension = true, showFileName = true }) => {
  const fileName = file?.file?.originalName as string
  const extension = fileName.split(".").pop()?.toLowerCase()
  const { truncatedFileName, isFileNameTruncated } = formatTruncatedFileName(fileName)

  const onFileClick = () => {
    void handleFileAction(file)
  }
  return (
    <Chip
      avatar={
        extension && showExtension ? (
          <Box className='flex w-fit items-center justify-center rounded bg-gray-500 p-1'>
            {extension.toUpperCase()}
          </Box>
        ) : undefined
      }
      label={
        showFileName &&
        (isFileNameTruncated ? (
          <Tooltip title={fileName}>
            <span>{truncatedFileName}</span>
          </Tooltip>
        ) : (
          <span>{truncatedFileName}</span>
        ))
      }
      variant='filled'
      size='small'
      className='h-auto max-w-[300px] rounded bg-gray-300 text-gray-900'
      sx={{ "& .MuiChip-label": { display: "block", whiteSpace: "normal", wordBreak: "break-word" } }}
      onClick={onFileClick}
      deleteIcon={<KeyboardArrowRightOutlined className='text-gray-800' />}
      onDelete={onFileClick}
      clickable
    />
  )
}

export default FileChip
